import { HeartHandshake, ShieldCheck, Truck, UtensilsCrossed } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import { COMMERCE } from '@/config/site';
import { formatCurrency } from '@/lib/format';

import { Container } from '../common/Container';

interface TrustItem {
  icon: LucideIcon;
  title: string;
  description: string;
}

const ITEMS: TrustItem[] = [
  {
    icon: ShieldCheck,
    title: 'Marcas de confiança',
    description: 'Royal Canin, Golden, PremierPet, Hill’s, Farmina e mais de 20 marcas.',
  },
  {
    icon: UtensilsCrossed,
    title: 'Nutrição para cada pet',
    description: 'Filhote, adulto ou sênior. Castrado, sensível ou controle de peso.',
  },
  {
    icon: Truck,
    title: 'Entrega rápida',
    description: `Grátis acima de ${formatCurrency(COMMERCE.freeShippingThreshold)} em São Paulo e região.`,
  },
  {
    icon: HeartHandshake,
    title: 'Atendimento humano',
    description: 'Gente de verdade no WhatsApp para indicar a ração certa.',
  },
];

export function TrustStrip() {
  return (
    <section className="bg-cream-300 py-10 lg:py-14" aria-label="Por que comprar na BrucePets">
      <Container>
        <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {ITEMS.map(({ icon: Icon, title, description }) => (
            <li
              key={title}
              className="flex gap-3 rounded-2xl border-2 border-sand-300 bg-white p-4 shadow-card transition-shadow hover:shadow-card-hover"
            >
              <span className="grid size-11 shrink-0 place-items-center rounded-xl bg-orange-100">
                <Icon className="size-5 text-orange-600" aria-hidden="true" />
              </span>

              <div>
                <h3 className="font-display text-sm font-bold text-brown-900">{title}</h3>
                <p className="mt-0.5 text-xs leading-relaxed text-brown-700">{description}</p>
              </div>
            </li>
          ))}
        </ul>
      </Container>
    </section>
  );
}
